export default function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/ramda/es/internal/_has.js
// module id = 27
// module chunks = 2 3 4 5 6 7 8 10